export const toAcres = (area, type) => {
  const HECTARES_TO_ACRES = 2.47105;
  if (type === 'hectares') {
    return area * HECTARES_TO_ACRES;
  }
  return area * 1;
};



// WEBPACK FOOTER //
// ./src/util/conversions.js